common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initNavbar();
        this.initScrollDown();
    },

    initNavbar()
    {
        // Give parent .active when has a .active subitem
        $('.navbar-nav .dropdown-menu > .dropdown-item.active').each(function(){
            $(this).parents('.nav-item').find('.nav-link').addClass('active');
        });
    },

    initScrollDown() {
        // Get scroll button and add listener
        this.element.find('.scroll-down').click((e) => {
            // On click find next block and scroll to it
            $([document.documentElement, document.body]).animate({
                scrollTop: this.element.find('.main').offset().top + 10
            }, 500);

            // Prevent default link behaviour
            e.preventDefault();
        });
    },
});
